import React from 'react';

import swal from 'sweetalert';

import clientData from '../../inc/clientData';
import config from '../../inc/config';
import { getCookie } from '../../inc/cookies';
import Images from '../../utils/Images';
import { Link } from 'react-router-dom';

class StoreInfoModule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            uploadLoading: false,
            storeExist: true,

            files: '',

            storeInfo: {}

        };
    }

    componentDidMount() {
        this.getStoreInfo();
        window.scrollTo(0, 0);
        console.log("StoreInfo: componentDidMount()");
    }

    componentWillUnmount() {
        console.log("StoreInfo: componentWillUnmount()");
    }

    getStoreInfo() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + clientData.sessionHash }
        };

        fetch(config.restApi + 'storeInfo/tr', requestOptions)
            .then(response => response.json())
            .then(responseData => {
                switch (responseData.status) {
                    case 200:
                        this.setState({ isLoading: false, storeInfo: responseData.storeInfo });
                        break;
                    case 404:
                        this.setState({ isLoading: false, storeExist: false });
                        break;
                    default:
                        swal({
                            dangerMode: true,
                            icon: 'warning',
                            title: 'Hay Aksi',
                            text: responseData.message,
                            buttons: 'Tamam'
                        }).then(this.setState({ isLoading: false }));
                        break;
                }
            }, () => swal({ dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam' }));
    }

    saveStoreLogo = () => {
        let sessionHash = getCookie('sessionHash');
        const formData = new FormData();

        formData.append('files', this.state.files[0]);

        const requestOptions = {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + sessionHash },
            body: formData,
        };

        this.setState({ uploadLoading: true });

        fetch(config.restApi + 'storeLogo/tr', requestOptions)
            .then((response) => response.json())
            .then(responseData => {
                switch (responseData.status) {
                    case 200:
                        swal({
                            dangerMode: true,
                            icon: 'success',
                            title: 'Başarılı',
                            text: 'Mağaza logosu başarıyla eklendi.',
                            buttons: 'Tamam'
                        }).then(() => {
                            this.setState({ isLoading: true }, () => {
                                this.getStoreInfo();
                                this.setState({ files: '' });
                                this.setState({ isLoading: false, uploadLoading: false });
                            });
                        });
                        break;
                    default:
                        swal({
                            dangerMode: true,
                            icon: 'warning',
                            title: 'Hay Aksi',
                            text: responseData.message,
                            buttons: 'Tamam'
                        }).then(() => { this.getStoreInfo(); this.setState({ uploadLoading: false }); });
                        break;
                }
            })
            .catch(() =>
                swal({
                    dangerMode: true,
                    icon: 'error',
                    title: 'Bağlantı Hatası',
                    text: 'Lütfen internet bağlantınızı kontrol ediniz.',
                    buttons: 'Tamam',
                }).then(() => this.setState({ uploadLoading: false })));
    };

    deleteStoreLogo = (storeId) => {
        swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Onayla',
            text: 'Mağaza logosunu silmek istediğinize emin misiniz?',
            buttons: { confirm: 'Tamam', cancel: 'Vazgeç' }
        }).then(value => {
            if (value) {
                let sessionHash = getCookie('sessionHash');

                const requestOptions = {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + sessionHash },
                };

                fetch(config.restApi + 'storeLogo/tr/' + storeId, requestOptions)
                    .then(response => response.json())
                    .then(responseData => {
                        switch (responseData.status) {
                            case 200: {
                                swal({
                                    dangerMode: true,
                                    icon: 'success',
                                    title: 'Tamamlandı',
                                    text: 'Mağaza logosu başarıyla silindi.',
                                    buttons: 'Tamam'
                                }).then(() => this.setState({ isLoading: true }, () => { this.getStoreInfo(); this.setState({ isLoading: false }); }));
                            }
                                break;
                            case 401:
                                swal({
                                    dangerMode: true,
                                    icon: 'warning',
                                    title: 'Hay Aksi',
                                    text: responseData.message,
                                    buttons: 'Tamam'
                                }).then(() => this.setState({ isLoading: true }, () => { this.getStoreInfo(); this.setState({ files: '' }); this.setState({ isLoading: false }); }));
                                break;
                            default: {
                                swal({
                                    dangerMode: true,
                                    icon: 'warning',
                                    title: 'Hay Aksi',
                                    text: responseData.message,
                                    buttons: 'Tamam'
                                }).then(() => this.setState({ isLoading: true }, () => { this.getStoreInfo(); this.setState({ files: '' }); this.setState({ isLoading: false }); }));
                            }
                                break;
                        }
                    }, () => swal({ dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam' }));
            }
        });
    }

    saveCoverImage = () => {
        let sessionHash = getCookie('sessionHash');
        const formData = new FormData();

        formData.append('files', this.state.files[0]);

        const requestOptions = {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + sessionHash },
            body: formData,
        };

        this.setState({ uploadLoading: true });

        fetch(config.restApi + 'storeCover/tr', requestOptions)
            .then((response) => response.json())
            .then(responseData => {
                switch (responseData.status) {
                    case 200:
                        swal({
                            dangerMode: true,
                            icon: 'success',
                            title: 'Başarılı',
                            text: 'Mağaza kapak resmi başarıyla eklendi.',
                            buttons: 'Tamam'
                        }).then(() => {
                            this.setState({ isLoading: true }, () => {
                                this.getStoreInfo();
                                this.setState({ files: '' });
                                this.setState({ isLoading: false, uploadLoading: false });
                            });
                        });
                        break;
                    default:
                        swal({
                            dangerMode: true,
                            icon: 'warning',
                            title: 'Hay Aksi',
                            text: responseData.message,
                            buttons: 'Tamam'
                        }).then(() => { this.getStoreInfo(); this.setState({ uploadLoading: false }); });
                        break;
                }
            })
            .catch(() =>
                swal({
                    dangerMode: true,
                    icon: 'error',
                    title: 'Bağlantı Hatası',
                    text: 'Lütfen internet bağlantınızı kontrol ediniz.',
                    buttons: 'Tamam',
                }).then(() => this.setState({ uploadLoading: false })));
    };

    deleteCoverImage = (storeId) => {
        swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Onayla',
            text: 'Mağaza kapak resmini silmek istediğinize emin misiniz?',
            buttons: { confirm: 'Tamam', cancel: 'Vazgeç' }
        }).then(value => {
            if (value) {
                let sessionHash = getCookie('sessionHash');

                const requestOptions = {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + sessionHash },
                };

                fetch(config.restApi + 'storeCover/tr/' + storeId, requestOptions)
                    .then(response => response.json())
                    .then(responseData => {
                        switch (responseData.status) {
                            case 200: {
                                swal({
                                    dangerMode: true,
                                    icon: 'success',
                                    title: 'Tamamlandı',
                                    text: 'Mağaza kapak resmi başarıyla silindi.',
                                    buttons: 'Tamam'
                                }).then(() => this.setState({ isLoading: true }, () => { this.getStoreInfo(); this.setState({ isLoading: false }); }));
                            }
                                break;
                            case 401:
                                swal({
                                    dangerMode: true,
                                    icon: 'warning',
                                    title: 'Hay Aksi',
                                    text: responseData.message,
                                    buttons: 'Tamam'
                                }).then(() => this.setState({ isLoading: true }, () => { this.getStoreInfo(); this.setState({ files: '' }); this.setState({ isLoading: false }); }));
                                break;
                            default: {
                                swal({
                                    dangerMode: true,
                                    icon: 'warning',
                                    title: 'Hay Aksi',
                                    text: responseData.message,
                                    buttons: 'Tamam'
                                }).then(() => this.setState({ isLoading: true }, () => { this.getStoreInfo(); this.setState({ files: '' }); this.setState({ isLoading: false }); }));
                            }
                                break;
                        }
                    }, () => swal({ dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam' }));
            }
        });
    }

    phoneFormat(phone) {
        let parsedValue = /^(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(phone);
        return parsedValue ? '(' + parsedValue[1] + ') ' + parsedValue[2] + ' ' + parsedValue[3] + ' ' + parsedValue[4] : '-';
    }

    render() {
        return this.state.isLoading ?
            <div className="ibox-content sk-loading position-static">
                <div className="sk-spinner sk-spinner-fading-circle">
                    <div className="sk-circle1 sk-circle"></div>
                    <div className="sk-circle2 sk-circle"></div>
                    <div className="sk-circle3 sk-circle"></div>
                    <div className="sk-circle4 sk-circle"></div>
                    <div className="sk-circle5 sk-circle"></div>
                    <div className="sk-circle6 sk-circle"></div>
                    <div className="sk-circle7 sk-circle"></div>
                    <div className="sk-circle8 sk-circle"></div>
                    <div className="sk-circle9 sk-circle"></div>
                    <div className="sk-circle10 sk-circle"></div>
                    <div className="sk-circle11 sk-circle"></div>
                    <div className="sk-circle12 sk-circle"></div>
                </div>
            </div>
            :
            this.state.uploadLoading ?
                <div>
                    <div className="d-flex justify-content-center"><strong>Dosyalar yüklenene kadar lütfen sayfada bekleyiniz!</strong></div>
                    <div className="progress">
                        <div className="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
                :
                <div className="mt-2">
                    <div className="row">
                        <div className="col d-flex justify-content-between">
                            <h3 className="text-darkblue">Mağaza Bilgilerim</h3>
                        </div>
                    </div>
                    <div className="hr-line-dashed mt-0"></div>
                    {this.state.storeExist === true ?
                        <div className="row">
                            <div className="col-md-6 my-2">
                                <h5 className="text-darkblue"><strong>Mağaza Linki</strong></h5>
                                <input className="form-control form-input" placeholder="Mağaza Adı" readOnly type="text" onClick={(e) => {
                                    if (navigator.clipboard && navigator.clipboard.writeText) {
                                        navigator.clipboard.writeText(e.target.value)
                                            .then(() => swal({
                                                dangerMode: true,
                                                icon: 'success',
                                                title: 'Tamamlandı',
                                                text: 'Link kopyalandı.',
                                                buttons: 'Tamam'
                                            }))
                                            .catch(err => console.error("Kopyalama hatası:", err));
                                    } else {
                                        // fallback
                                        e.target.select();
                                        document.execCommand("copy");
                                        swal({
                                            dangerMode: true,
                                            icon: 'success',
                                            title: 'Tamamlandı',
                                            text: 'Link kopyalandı.',
                                            buttons: 'Tamam'
                                        })
                                    }
                                }} value={'https://' + this.state.storeInfo.storename + `.${config.host}`} />
                            </div>
                            <div className="col-md-6 my-2">
                                <h5 className="text-darkblue"><strong>E-posta</strong></h5>
                                <input className="form-control form-input" placeholder="Mağaza Adı" readOnly type="text" value={this.state.storeInfo.email} />
                            </div>
                            <div className="col-12 my-2">
                                <h5 className="text-darkblue"><strong>Mağaza Logosu (700 X 400)</strong></h5>
                                {this.state.storeInfo.logoPath &&
                                    <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                                        <div style={{ position: "relative", display: "inline-block", border: "1px solid lightgray", backgroundColor: "#F5F5F5" }}>
                                            <img className='col-12 p-0' style={{ height: 300, width: 533, objectFit: "contain", overflow: "visible", display: "block" }} src={`https://file.satisgaranti.com/${this.state.storeInfo.logoPath}`}></img>
                                            <button className="btn btn-default btn-circle" title='Sil' onClick={() => this.deleteStoreLogo(this.state.storeInfo.id)} style={{ position: "absolute", top: 0, right: 0 }}><i className="fa fa-close" style={{ pointerEvents: 'none', color: "black" }}></i></button>
                                        </div>
                                    </div>
                                }
                                <form className="d-flex align-items-center justify-content-center dropzone">
                                    <div className="fallback">
                                        <input accept=".jpg, .jpeg, .png" name="file" onChange={(e) => { this.setState({ files: e.target.files }, () => { this.saveStoreLogo(); }); }} style={{ paddingLeft: "15%" }} type="file" />
                                    </div>
                                </form>
                            </div>
                            <div className="col-12 my-2">
                                <h5 className="text-darkblue"><strong>Mağaza Kapak Resmi (1200 X 360)</strong></h5>
                                {this.state.storeInfo.coverPath &&
                                    <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                                        <div style={{ position: "relative", display: "inline-block", border: "1px solid lightgray", backgroundColor: "#F5F5F5" }}>
                                            <img className='col-12 p-0' style={{ height: 300, width: 533, objectFit: "contain", overflow: "visible", display: "block" }} src={`https://file.satisgaranti.com/${this.state.storeInfo.coverPath}`}></img>
                                            <button className="btn btn-default btn-circle" title='Sil' onClick={() => this.deleteCoverImage(this.state.storeInfo.id)} style={{ position: "absolute", top: 0, right: 0 }}><i className="fa fa-close" style={{ pointerEvents: 'none', color: "black" }}></i></button>
                                        </div>
                                    </div>
                                }
                                <form className="d-flex align-items-center justify-content-center dropzone">
                                    <div className="fallback">
                                        <input accept=".jpg, .jpeg, .png" name="file" onChange={(e) => { this.setState({ files: e.target.files }, () => { this.saveCoverImage(); }); }} style={{ paddingLeft: "15%" }} type="file" />
                                    </div>
                                </form>
                            </div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-12 d-block notFoundImg">
                                <div className="text-center">
                                    <img className="m-4" src={Images.whyStore} />
                                </div>
                                <div className="text-center my-auto">
                                    <h2 className="mb-1 mt-2"><b className="text-orange">Mağaza Bulunamadı!</b></h2>
                                    <h3 className="m-0 pb-4 text-darkblue text-left">Mağaza, satisgaranti.com gibi bir platformda ürünlerinizi satmak veya kiralamak için oluşturulan özel bir hesaptır. Mağaza açarak, ürün veya hizmetlerinizi milyonlarca potansiyel müşteriye sunabilirsiniz. Bu, daha geniş bir kitleye erişmenizi sağlar ve potansiyel alıcıları çeker.</h3>
                                </div>
                                <div className="d-flex justify-content-start mb-3">
                                    <Link className="btn bg-orange text-white font-bold mr-2" onClick={this.updateAccountInfoOnClick} target="_blank" to={`https://www.${config.host}/magaza-acmak-istiyorum`}><i className="fa fa-shopping-cart mr-2"></i>Mağaza Aç</Link>
                                    <Link className="btn bg-orange text-white font-bold" onClick={this.updateAccountInfoOnClick} target="_blank" to={`https://www.${config.host}/magaza-hakkinda-detayli-bilgi-almak-istiyorum`}><i className="fa fa-info-circle mr-2"></i>Detaylı Bilgi</Link>
                                </div>
                            </div>
                        </div>
                    }
                </div>
    }
}

export default function StoreInfo() {
    return (
        <StoreInfoModule />
    )
}